import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { RedeemRequestDTO } from 'src/app/shared/models/dtos/requests/redeem-request-dto/redeem-request-dto';
import { Coupon } from 'src/app/shared/models/dtos/responses/coupon/coupon';
import { PointSummaryDTO } from 'src/app/shared/models/dtos/responses/point-summary/point-summary-dto';
import { Reward } from 'src/app/shared/models/reward/reward';
import { RewardService } from '../../api/reward/reward.service';

@Injectable({
  providedIn: 'root',
})
/**
 * Reward Management Service~!
 * This service is a client of reward service,
 */
export class RewardManagementService {
  private _points?: number;
  /* eslint-disable */
  knownCoupons: {
    [key: number]: Coupon;
  } = {
      42: JSON.parse(
        '{"id": 42, "rewardId": 1, "pointIds": [], "businessId": 2, "redeemDate": "2022-08-09T22:06:31.364+00:00", "usedDate": "2022-08-09T22:06:31.364+00:00", "expirationDate": "2023-02-05T22:06:30.552+00:00", "resellerIdentification": "resellerinfo", "hash": "htPntmxi3KYoCcW2DrZzxg==", "status": "ACTIVE" }'
      ),
    };
  /* eslint-enable */
  /**
   * @constructor
   */
  constructor(public readonly rewardService: RewardService) {}

  /**
   * gets points
   */
  get points() {
    return this._points;
  }

  /**
   * Fetches and updates points from reward service
   * @param {number} familyId
   * @return {Promise<PointSummaryDTO>}
   */
  async pullPoints(familyId: number): Promise<PointSummaryDTO> {
    const pulledPoints = await firstValueFrom(
      this.rewardService.getPointSummary(familyId)
    );
    this._points = pulledPoints.totalPoints;

    return pulledPoints;
  }

  /**
   * Redeems a reward
   * @param {number} rewardId
   * @param {number} familyId
   * @param {string} equipmentSerial
   * @return {Coupon}
   */
  async redeemReward(
    rewardId: number,
    familyId: number,
    equipmentSerial?: string
  ): Promise<Coupon> {
    const coupon = await firstValueFrom(
      this.rewardService.redeemReward(
        rewardId,
        new RedeemRequestDTO('resellerinfo', familyId, equipmentSerial)
      )
    );
    this.knownCoupons[coupon.id!] = coupon;
    return coupon;
  }

  /**
   * Gets a reward from reward service
   * @param {number} rewardId
   */
  async getReward(rewardId: number): Promise<Reward> {
    const reward = await firstValueFrom(this.rewardService.getReward(rewardId));
    return reward;
  }

  /**
   * Gets a reward from coupon service
   * @param {number} couponId
   */
  async getCoupon(couponId: number): Promise<Coupon> {
    const coupon = await firstValueFrom(this.rewardService.getCoupon(couponId));
    return coupon;
  }
}
